// src/screens/tabs/Menu/components/SubCategorySection.tsx
import React, { useState } from "react";
import { View, Text } from "react-native";
import { ToggleLeft } from "lucide-react-native";
import { MenuItemType, SubCategory } from "../../types/restaurant.types";
import { menuScreenStyles as styles } from "../../styles/styles";
import { FlickOColors } from "../../styles/color";
import { MenuItemCard } from "./MenuItemCard";
import { config } from "../../../../config";
import { cs } from "../../constant";

interface SubCategorySectionProps {
  subCategory: SubCategory;
  onAddToCart: (item: MenuItemType, quantity: number) => void;
}

export const SubCategorySection: React.FC<SubCategorySectionProps> = ({
  subCategory,
  onAddToCart,
}) => {
  const [isEnabled, setIsEnabled] = useState(subCategory.isEnabled);

  return (
    <View style={styles.subCategoryContainer}>
      <View style={styles.subCategoryHeader}>
        <Text style={styles.subCategoryTitle}>{subCategory.name}</Text>
        {subCategory.name &&
          subCategory.name.length &&
          config.app.name === cs.partnerApp && (
            <View
              style={[
                styles.toggleButton,
                isEnabled && styles.toggleButtonEnabled,
              ]}
            >
              <ToggleLeft
                size={20}
                color={
                  isEnabled ? FlickOColors.success : FlickOColors.text.secondary
                }
              />
              <Text
                style={[
                  styles.toggleText,
                  isEnabled && styles.toggleTextEnabled,
                ]}
              >
                {isEnabled ? "In Stock" : "Out Of Stock"}
              </Text>
            </View>
          )}
      </View>

      <View>
        {subCategory.items.length > 0 ? (
          subCategory.items.map((item, index) => (
            <MenuItemCard
              key={item.id}
              item={item}
              isLastItem={index === subCategory.items.length - 1}
              onAddToCart={onAddToCart}
            />
          ))
        ) : (
          <Text style={styles.emptyText}>No items added yet</Text>
        )}
      </View>
    </View>
  );
};
